import { Link, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Logo from "components/common/Logo";

const Footer = () => {
  const theme = useTheme();
  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        margin: "2rem -1rem -1rem -1rem",
        padding: "1rem",
        borderBottomLeftRadius: "0.25rem",
        borderBottomRightRadius: "0.25rem",
        background: theme.brand.accent[200],
      }}
    >
      <Logo variant={"poweredBy"} />
      <Link
        variant={"caption"}
        color={"secondary"}
        href={"https://cactusrisk.com"}
      >
        {"cactusrisk.com"}
      </Link>
    </Stack>
  );
};

export default Footer;
